import z from "zod";

import request from "../base-request";

export const OutlookColorSchema = z.object({
	id: z.string(),
	name: z.string(),
	color: z.string(),
});

export type OutlookColor = z.infer<typeof OutlookColorSchema>;

export type IOutlookColorData = {
	colors: OutlookColor[];
};

export const getOutlooks = async () => {
	const [data] = await request<IOutlookColorData>(`/api/v1.0/strategy-colors/`);

	return data;
};
